exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mo-table[data-v-0bcbce61]{width:100%}.mo-table-header-row[data-v-0bcbce61]{background-color:#e3e3e3}[data-v-0bcbce61] .mo-table-header-cell{background-color:#fafafa;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bcbce61","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/table/main.vue
// module id = 196
// module chunks = 0